import React from 'react';

export default function DeliveryZoneField({ label, field, errors, className }) {
  return (
    <div className={className}>
      <div className="flex">
        <div className="w-1/2 flex">{label}</div>
        <div className="w-1/2">{field}</div>
      </div>
      <div className="text-sm text-brand-danger">{errors}</div>
    </div>
  );
}
